import React from "react";
import "../../styles/Common/InputSlider.less";
import CalculatorStore from "../../Configs/Store/calculator";
import { observer } from "mobx-react"

const InputSlider = observer(((props) => {
  const expensesKeypress = (event) => { 
    return CalculatorStore.setCurrentChar(event.key)
  }
  
  return (
    <>
      <div className={`CustomRangeOuter ${CalculatorStore.screenNo}`}>
        <label htmlFor="customRange1">{CalculatorStore.customRange1Text}</label>
        <span className="form-control custom-range-input-field">
          <input type="tel" name="ageInput" className="age_input" onKeyPress={expensesKeypress} pattern="[0-9]*" onChange={props.handleAgeVal} value={CalculatorStore.screenNo === "Scr1" ? CalculatorStore.ageValue : CalculatorStore.retireAgeValue} maxLength={2} /> years
        </span>
        <div className="custom-range-wrap">
          <span className="age-start">{CalculatorStore.minValue}</span>
          <input type="range" name="ageSlide" className="custom-range chrome-css" id="customRange1" min={CalculatorStore.minValue} max={CalculatorStore.maxValue} step="1" style={{backgroundSize : CalculatorStore.bgSize + '% 100%'}} onChange={props.handleAgeVal} value={CalculatorStore.rangeInput} />
          <span className="age-end">{CalculatorStore.maxValue}</span>
        </div>
      </div>
      { !CalculatorStore.errorAge && <div className="error mt-1">{CalculatorStore.errorMessage}</div> }
    </>
  )
}) )

export default InputSlider
